import LoyaltyGauge from './LoyaltyGauge';
export default LoyaltyGauge;